import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CalculateService } from 'app/calculate/calculate.service';
import { ContexService } from 'app/utils/contex/contex.service';
import { MetaTagsHelper } from 'app/utils/metaTags/metaTagsHelper';
import { NavigationService } from 'app/utils/navigation/navigation.service';

@Component({
    selector: 'app-cover-info',
    templateUrl: './cover-info.component.html',
    styleUrls: ['./cover-info.component.less'],
})
export class CoverInfoComponent implements OnInit {
    contex: any;
    product: string;
    cover: string;
    coverIcon: string;
    newCarProduct: boolean;

    constructor(
        public navigationService: NavigationService,
        public contexService: ContexService,
        private metaTagsHelper: MetaTagsHelper,
        private route: ActivatedRoute,
        private calculateService: CalculateService
    ) {}

    getEasyUrl(product: string) {
        switch (product) {
            case 'CAR':
                return 'https://ssp.easysure.dk/sales-journey/carLiability/?kpcid=20000131';
            case 'CAR_SIMPLE':
                return 'https://ssp.easysure.dk/sales-journey/carLiability/?kpcid=20000131';
            case 'HOUSE':
                return 'https://ssp.easysure.dk/sales-journey/buildingFire?accept-language=da/?kpcid=20000131';
            case 'HOME':
                return 'https://ssp.easysure.dk/sales-journey/carLiability/?kpcid=20000131';
            case 'DOG':
                return 'https://ssp.easysure.dk/sales-journey/dogLiability?accept-language=da/?kpcid=20000131';
            case 'SECONDHOUSE':
                return 'https://ssp.easysure.dk/sales-journey/holidayHomeFire?accept-language=da/?kpcid=20000131';
            case 'CARAVAN':
                return 'https://ssp.easysure.dk/sales-journey/caravanComprehensive/?kpcid=20000131';
            case 'MOPED':
                return 'https://ssp.easysure.dk/sales-journey/mopedLiability/?kpcid=20000131';
            case 'ACCIDENT':
                return 'https://ssp.easysure.dk/sales-journey/disabilityCover?accept-language=da/?kpcid=20000131';
            default:
                return 'https://ssp.easysure.dk/products?accept-language=da/?kpcid=20000131';
        }
    }

    ngOnInit(): void {
        this.route.data.subscribe((x) => {
            console.log(x);
            this.product = x.product;
            this.cover = x.cover;
            this.coverIcon = x.coverIcon;
            this.newCarProduct = x.newCarProduct;
            console.log(this.product, this.cover);

            if (this.newCarProduct) {
                this.calculateService.validateNewCarAllowed();
            }

            // TODO We should use title and description from the contexService instead of the translation service
            this.metaTagsHelper.setTitleAndMetaTags('META.COVER_' + this.product.toUpperCase() + '_' + this.cover.toUpperCase());

            const pagecode = this.navigationService.getPathObject('cover-' + this.product.toLowerCase() + '-' + this.cover.toLowerCase()).contexPageCode;

            this.contexService.getContent(pagecode).subscribe((content) => {
                this.contex = content;
            });
        });
    }
}
